import { useNavigate } from "react-router-dom";

export default function Index() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-blue-200 flex flex-col">
      {/* Hero Section */}
      <section className="flex flex-col-reverse md:flex-row items-center justify-between max-w-6xl mx-auto px-6 py-16 md:py-24">
        {/* Text */}
        <div className="md:w-1/2 text-center md:text-left">
          <h1 className="text-4xl md:text-6xl font-extrabold text-gray-800 mb-6">
            Living Wage Scraper
          </h1>
          <p className="text-lg md:text-xl text-gray-700 mb-8">
            Welcome to the Living Wage data validation system. The registration has been suspended for now. Which means you will only be able to log in using credentials you have received from the owner.
          </p>
          <div className="flex flex-col md:flex-row gap-4 justify-center md:justify-start">
            <button
              onClick={() => navigate("/login")}
              className="px-6 py-3 bg-blue-600 text-white rounded-lg shadow hover:bg-blue-700 transition-colors"
            >
              Login
            </button>
            <button
              onClick={() => navigate("/register")}
              className="px-6 py-3 bg-white text-blue-600 border border-blue-600 rounded-lg shadow hover:bg-blue-50 transition-colors"
            >
              Register
            </button>
          </div>
        </div>

        {/* Illustration / Hero Image */}
        <div className="md:w-1/2 mb-8 md:mb-0 flex justify-center">
          <div className="w-80 h-64 bg-white rounded-xl shadow-lg flex items-center justify-center text-gray-400 font-bold">
            Dashboard Mockup
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="bg-white py-16">
        <div className="max-w-6xl mx-auto px-6">
          <h2 className="text-3xl font-bold text-gray-800 text-center mb-12">
            Key Features
          </h2>
          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-blue-50 p-6 rounded-xl shadow hover:shadow-lg transition-shadow">
              <h3 className="text-xl font-semibold mb-2">Real-Time Analytics</h3>
              <p className="text-gray-700">
                Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
              </p>
            </div>
            <div className="bg-blue-50 p-6 rounded-xl shadow hover:shadow-lg transition-shadow">
              <h3 className="text-xl font-semibold mb-2">Custom Dashboards</h3>
              <p className="text-gray-700">
                Curabitur pretium tincidunt lacus. Nulla gravida orci a odio. Nullam varius, turpis et commodo pharetra, est eros bibendum elit, nec luctus magna felis sollicitudin mauris. Integer in mauris eu nibh euismod gravida.
              </p>
            </div>
            <div className="bg-blue-50 p-6 rounded-xl shadow hover:shadow-lg transition-shadow">
              <h3 className="text-xl font-semibold mb-2">Secure & Verified</h3>
              <p className="text-gray-700">
                Curabitur pretium tincidunt lacus. Nulla gravida orci a odio. Nullam varius, turpis et commodo pharetra, est eros bibendum elit, nec luctus magna felis sollicitudin mauris. Integer in mauris eu nibh euismod gravida.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Footer / Call to Action */}
      <section className="bg-blue-100 py-12 text-center">
        <h3 className="text-2xl font-bold mb-4">Get Started Today</h3>
        <p className="text-gray-700 mb-6">
          Sign up.
        </p>
        <button
          onClick={() => navigate("/register")}
          className="px-8 py-3 bg-blue-600 text-white rounded-lg shadow hover:bg-blue-700 transition-colors"
        >
          Register Now
        </button>
      </section>
    </div>
  );
}
